import { ReactNode } from 'react';
import { EventSearchTabsProvider } from './event-search-tabs-provider';

export function EventSearchProvider({
    initialTab,
    children,
}: {
    initialTab: string;
    children: ReactNode;
}) {
    return <EventSearchTabsProvider initialTab={initialTab}>{children}</EventSearchTabsProvider>;
}
